import { type ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function CallBanner({ text }: { text: string }) {
  return (
    <section className="mx-auto max-w-7xl px-6 my-20">
      <div className="rounded-2xl bg-primary px-8 py-12 md:px-14 md:py-16 text-primary-foreground flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <p className="font-display text-2xl md:text-3xl max-w-2xl">{text}</p>
        <a href="tel:6824545997" className="inline-flex items-center justify-center rounded-md bg-accent px-6 py-3.5 text-base font-semibold text-accent-foreground hover:opacity-90 shrink-0">
          Call 682-454-5997
        </a>
      </div>
    </section>
  );
}
